module.exports = __webpack_public_path__ + "static/salary_11.683f228e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/salary/assets/salary_11.jpg
// module id = 409
// module chunks = 32503283977284